import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BASE_PATH } from '@lkp/parking-sdk';
import { environment } from 'src/environments/environment';
import { SharedModule } from '../shared/shared.module';
import { RelyitModule } from '../pages/relyit/relyit.module';
import { AuthorizationInterceptor } from './interceptors/authorization-interceptor';

@NgModule({
  declarations: [],
  imports: [CommonModule, SharedModule, RelyitModule],
  providers: [
    { provide: BASE_PATH, useValue: environment.backendServerUrl },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthorizationInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        `CoreModule has already been loaded. Import Core modules in the AppModule only.`
      );
    }
  }
}
